<template>
    <v-dialog v-model="dialog" max-width="400px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="text-lowercase mr-4" 
            dark small v-on="on">add game</v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6">
                New game parameters
            </v-card-title>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field dense color="primary" 
                                    label="current round" 
                                    v-model.number="round"
                                    type="text"
                                    :rules="[rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-select dense color="primary"
                                    label="category" 
                                    v-model="category"
                                    :items="categories" 
                                    :rules="[rules.required]">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea outlined dense color="primary" 
                                    label="description"
                                    v-model="description" name="description"
                                    :rules="[rules.required]" 
                                    @change="onceMore()">
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error">{{ error }}</v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" :disabled="!valid || Boolean(error)"
                    @click="addGame">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'AddGame',
    props: ['set'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            categories: ['simple', 'standart', 'advanced'],
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'
            },
            //props
            round: 0,
            category: 'standart',
            description: '',
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        }
    },
    methods: {

        onceMore() {
            this.error = ''
        },
        async addGame() {

            let id = 2;

            switch (this.category) {
                case 'simple': id = 1;
                break;
                case 'advanced' : id = 3;
                break;
                default: id = 2;
            }

            if (this.$refs.form.validate()) {
                const game = {
                    id: id,
                    category: this.category,
                    round: this.round,
                    description: this.description,
                }
                //console.log(game);
                try {
                    //add game
                    await this.$store.dispatch('addGame', game)
                    this.closeDialog()
                }
                catch (error) {
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false
            this.error = ''
            this.round = 0
            this.category = 'standart'
            this.description = ''
        }
    }
}
</script>
